import type { ShapeName } from '@shared/constants';

interface ShapeProps {
  shape: ShapeName;
  className?: string;
  /** Defaults to currentColor. */
  fill?: string;
  title?: string;
}

/** Answer shape glyph (triangle, diamond, circle, square). */
export function Shape({ shape, className, fill = 'currentColor', title }: ShapeProps) {
  return (
    <svg
      viewBox="0 0 100 100"
      className={className}
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
    >
      {shape === 'triangle' && <polygon points="50,8 94,88 6,88" fill={fill} strokeLinejoin="round" />}
      {shape === 'diamond' && <polygon points="50,4 96,50 50,96 4,50" fill={fill} />}
      {shape === 'circle' && <circle cx="50" cy="50" r="44" fill={fill} />}
      {shape === 'square' && <rect x="10" y="10" width="80" height="80" rx="6" fill={fill} />}
    </svg>
  );
}
